import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getAppIntroduction } from "../../utils/Utilities";
import "./discoverMore.scss";

const Introduction = () => {
  const { t } = useTranslation();
  const [appIntroduction, setAppIntroduction] = useState([]);
  const [elementIndex, setElementIndex] = useState(0);

  useEffect(() => {
    setAppIntroduction(getAppIntroduction(t) || []);
  }, [t]);

  return (
    <Box
      className="introduction"
      sx={{
        flexWrap: { md: "nowrap", xs: "wrap" },
        justifyContent: { md: "start", xs: "center" },
      }}
    >
      <div className="content">
        <div
          className="heading"
          dangerouslySetInnerHTML={{
            __html: appIntroduction[0]?.heading,
          }}
        />
        <div
          className="details"
          dangerouslySetInnerHTML={{
            __html: appIntroduction[0]?.description,
          }}
        />
      </div>
      <Box className="carousel">
        <div className="carousel-count">
          {["01", "02", "03"].map((elem, index) => (
            <>
              <div
                className={`carousel-element ${
                  elementIndex === index && "active"
                }`}
              >
                <p onClick={() => setElementIndex(index)}>{elem}</p>
                <div
                  className={`${
                    elementIndex === index ? "show-bar" : "hide-bar"
                  }`}
                />
              </div>
            </>
          ))}
        </div>
        <div className="carousel-bar">
          {["intro.family-tree", "intro.assets", "intro.documents"].map(
            (elem, index) => (
              <div
                style={{
                  opacity: elementIndex === index ? 1 : 0,
                  overflow: elementIndex === index ? "inherit" : "hidden",
                }}
              >
                <p>{t(elem)}</p>
              </div>
            )
          )}
        </div>
        <Box
          className="image"
          dangerouslySetInnerHTML={{
            __html: appIntroduction[0]?.image[elementIndex],
          }}
        />
      </Box>
    </Box>
  );
};

export default Introduction;
